export default {
  data() {
    return {
      title: 'Как работает техподдержка',
      advantages: [
        {
          id: 1,
          title: 'Помогаем 24/7',
          text: 'Проводите вебинары в\u00A0любое время. Мы\u00A0всегда на\u00A0связи, чтобы\u00A0оперативно решить любой вопрос',
          icon: require('~/assets/img/faq_and_support/icon_1.svg'),
          iconName: 'icon_1',
        },
        {
          id: 2,
          title: 'Сопровождаем вебинары\n',
          text: 'На ответственный вебинар можно пригласить технического специалиста. Он проконтролирует, чтобы\u00A0все прошло гладко',
          icon: require('~/assets/img/faq_and_support/icon_6.svg'),
          iconName: 'icon_6',
        },
        {
          id: 3,
          title: 'Консультируем участников',
          text: 'Поддерживаем не\u00A0только организаторов, но\u00A0и\u00A0слушателей вебинаров. Ваши участники получат необходимую помощь',
          icon: require('~/assets/img/faq_and_support/icon_5.svg'),
          iconName: 'icon_5',
        },
      ],
    }
  },
}
